import Errors from 'Core/commons/Errors';
export default {
    props: {
        preset: {
            type: Object,
            required: false,
            default: () => {},
        },
    },
    data() {
        return {
            errors: new Errors(),
        };
    },
    methods: {
        /**
         * /!\ Only for third creation form /!\
         * @param {*} formName (string) : ref value in form component's props
         * @param {*} methodName (string) : customMethod called if form is valid
         * @param {*} payload () : return value when form is valid
         * @param {*} scroll (boolean) : allow scroll if error
         */
        submitForm(formName, methodName, payload = false, scroll = false) {
            this.errors.clearAll();
            this.$refs[formName].validate((valid, fields) => {
                if (valid && !this.errors.hasOne()) {
                    if (methodName && methodName !== undefined && typeof methodName === 'string') {
                        this[methodName](payload);
                    } else {
                        this.save(payload);
                    }
                } else {
                    const msg = Object.entries(fields)[0];
                    const match = msg[0].match(
                        /^(groupedCustomFields\.[0-9]{1,}\.fields\.[0-9]{1,}\.value)$/,
                    );

                    if (!_.isNil(msg) && !_.isNil(match)) {
                        Push.error(msg[1][0].message);
                    } else {
                        const message =
                            msg[1][0].message.length > 0
                                ? msg[1][0].message
                                : this.$l10n.__("Une erreur s'est produite.", false);
                        Push.error(message);
                    }
                    if (!!scroll) {
                        const currentRef = msg[0];
                        let type = 'main';
                        if (!_.isNil(match)) {
                            type = 'custom-fields';
                        } else if (currentRef.indexOf('-') >= 0) {
                            type = currentRef.slice(0, currentRef.indexOf('-'));
                        }

                        //scroll to field if it was referenced
                        if (!_.isNil(match)) {
                            this.$parent?.$refs[type]?.$refs[currentRef][0]?.$el.scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                                inline: 'end',
                            });
                        } else {
                            this.$parent?.$refs[type]?.$refs[currentRef]?.$el.scrollIntoView({
                                block: 'center',
                                behavior: 'smooth',
                                inline: 'nearest',
                            });
                        }
                    }
                    return false;
                }
            });
        },
        scrollToTop() {
            document.getElementById('sellsy_app').scrollTo({ top: 0, behavior: 'smooth' });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    },
};
